import { ModulosMotivoENUM } from '@/shared';
import ComentariosBitacoraDialog from '@/shared/components/ui/ComentariosBitacoraDialog/ComentariosBitacoraDialog';
import BitacoraDialog from '@/shared/components/ui/CrearBitacoraDialog/CrearBitacoraDialog';
import { useDiccionarioMotivo } from '@/store/erp/diccionario_motivo/diccionario_motivo.store';
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

export type ControlCambiosModuleProps = {};

const ControlCambiosModule: React.FC<ControlCambiosModuleProps> = () => {

  (async () => {
    await Promise.all([
    ]);
  })();



  const emitRegistrarUsuario = useDiccionarioMotivo().emitRegistrarUsuario
  const setDepartamento = useDiccionarioMotivo().setDepartamento
  const socket = useDiccionarioMotivo().socket


  useEffect(() => {
    setDepartamento(ModulosMotivoENUM.BITACORA_PYL)
    emitRegistrarUsuario()
    
  }, [socket])


  return (
    <>
      <Outlet />
      <ComentariosBitacoraDialog />
      <BitacoraDialog />
    </>
  );
};

export default ControlCambiosModule;
